module.exports = __webpack_public_path__ + "static/img/first.586a058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandLanshu/first.png
// module id = MCjc
// module chunks = 0